<section>
	<main>
		<header>
			<h1>Get the most out of your Startpage!</h1>
		</header>
		<div class="button_container">
			<a href="https://addons.mozilla.org/firefox/addon/myanimetab/">Install MyAnimeTab Now!</a>
		</div>
	</main>
</section>
<style>
	section {
		/* background: linear-gradient(255deg, #f8428e, var(--install-color)); */
		background: linear-gradient(225deg, var(--widget-list-color) 20%, #60817d);
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
	}

	h1 {
		font-size: 70px;
		font-weight: 400;
		line-height: 1.5;
		max-width: 600px;
		color: var(--landing-color);
		text-align: center;
	}

	.button_container {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	a {
		font-size: 25px;
		font-weight: 500;
		line-height: 1.4;
		padding: 1em;
		border-radius: 4px;
		background-color: var(--landing-color);
		border: none;
		cursor: pointer;
		color: var(--nav-color);
		text-align: center;
	}

	a:hover {
		filter: brightness(0.9);
	}

</style>